import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { ButtonDesktop as Button } from '@alfa-bank/site-button-v2/desktop';
import { ImgV2 as Img } from '@alfa-bank/site-img-v2';
import { Stack, stackingOrder } from '@alfa-bank/site-stack';

import type { IYandexSearchBarDesktopDeps, TYandexSearchBarDesktop } from '../../models';
import { SuggestBlockDesktop as SuggestBlock } from '../components/suggestBlock/desktop';
import { YandexSearchInputDesktop as YandexSearchInput } from '../components/yarndex-search-input/desktop';
import styles from '../styles/styles.css';

import { YandexSearchBarDesktop as Component } from './yandex-search-bar';

export const YandexSearchBar = createWidget<IYandexSearchBarDesktopDeps, TYandexSearchBarDesktop>({
    styles,
    Img,
    Button,
    Stack,
    SuggestBlock,
    YandexSearchInput,
    stackingOrder,
})(Component);
